class MultiStepFormState {
  constructor(steps) {
    this.steps = steps;
    this.currentStepIndex = 0;
  }

  next() {
    if (this.steps.length == 0) return;

    if (this.steps.length <= this.currentStepIndex + 1) return;

    this.currentStepIndex += 1;
  }

  prev() {
    if (this.steps.length == 0) return;

    if (this.currentStepIndex <= 0) return;

    this.currentStepIndex -= 1;
  }

  currentStep() {
    if (this.steps.length == 0) return null;

    return this.steps[this.currentStepIndex];
  }

  inactiveSteps() {
    if (this.steps.length == 0) return [];

    return [
    ...this.steps.slice(0, this.currentStepIndex),
    ...this.steps.slice(this.currentStepIndex + 1),
    ];
  }

  activeSteps() {
    return [this.currentStep()].filter(step => step != null);
  }

  isSingleStep() {
    return this.steps.length <= 1;
  }

  isFirstStep() {
    return this.steps.length > 0 && this.currentStepIndex == 0;
  }

  isLastStep() {
    return this.steps.length > 0 && this.currentStepIndex == this.steps.length - 1;
  }
}

export { MultiStepFormState };